const firebaseConfig = {
    apiKey: "AIzaSyB51LLaNMiU9OWonoKHVhQNTrmPfFVjK7k",
    authDomain: "burj-al-arab-6944f.firebaseapp.com",
    databaseURL: "https://burj-al-arab-6944f.firebaseio.com",
    projectId: "burj-al-arab-6944f",
    storageBucket: "burj-al-arab-6944f.appspot.com",
    messagingSenderId: "59129206914",
    appId: "1:59129206914:web:cee17e2d7b9053357abc9b"
  };

  export default firebaseConfig;